// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__21PXV","right":"styles_right__O0p2M"};